<template>
    <div v-if="!isMobile" class="template-generator-desktop">
        <button class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>

        <b-modal id="preview" size="lg" title="Şablon Önizlemesi" hide-footer scrollable no-close-on-esc no-close-on-backdrop>
            <template-generator-preview :layout="previewLayout"></template-generator-preview>
        </b-modal>
        
        <div class="row">
            <div class="col-md-3">
                <div class="sticky">
                    <b-overlay :show="templateLoading" opacity="0.2" rounded="sm">
                        <b-card v-if="schemeName || schemeDescription" class="mb-1">
                            <h5 class="mb-0 font-weight-bolder">{{schemeName}}</h5>
                            <p class="mb-0 mt-50">{{schemeDescription}}</p>
                        </b-card>
                        <b-card >
                            <button :disabled="layout.length == 0" v-on:click="preview" class="btn btn-block btn-success btn-md mb-1">
                                <div class="d-flex align-items-center justify-content-center">
                                    <span class="material-icons-round mr-50">play_circle</span>
                                    Önizleme
                                </div>
                            </button>
                            <button class="btn btn-sm w-100 mb-1 btn-outline-danger" v-on:click="resetLayout">
                                Sıfırla
                            </button>
                            <div class="mb-2">
                                <label class="form-label">Belge İsmi</label>
                                <input class="form-control" placeholder="Belge İsmi" v-model="name"/>
                            </div>
                            <ul class="list-group mb-1">
                                <li class="list-group-item bg-secondary text-white">Şablon Nesneleri</li>
                                <li class="list-group-item d-flex justify-content-between align-items-center" :class="{'disabled':!itemAddable(comp)}" v-on:click="addItem(comp)" v-for="(comp,index) in components" :key="index">
                                    {{comp.n}}
                                    <span class="badge badge-secondary badge-pill">{{itemCount(comp)}}</span>
                                </li>
                            </ul>
                            <v-executer full-width :loading="loading" text="Kaydet" :action="save"></v-executer>
                        </b-card>
                    </b-overlay>
                </div>
            </div>
            <div class="col-md-9">
                <b-overlay :show="templateLoading" opacity="0.2" rounded="sm">
                    <b-card class="mb-0">
                        <div v-if="!layout.length" class="empty-template text-center">
                            <div class="text-secondary mb-50 font-weight-bold">Şu an için şablonda bir nesne bulunmamaktadır.</div>
                            <div>Sol tarafta bulunan şablon nesnelerinden birini seçebilir;</div>
                            <div>sayfadaki <b>konumunu</b>, <b>genişliğini</b>, <b>yüksekliğini</b>, veya <b>içeriğini</b> düzenleyebilirsiniz.</div>
                        </div>
                        <grid-layout v-else class="grid" :vertical-compact="false" :layout.sync="layout" :col-num="colNum" :row-height="30" :is-draggable="true" :is-resizable="true" :use-css-transforms="true">
                            <grid-item :class="{'editor':$safe(item,'e')}" v-for="(item) in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i" :is-resizable="item.r" :drag-ignore-from="item.dif">
                                <div class="grid-item-wrapper">
                                    <button class="delete-button btn btn-danger btn-sm" v-on:click="removeItem(item.i)">Sil</button>
                                    <component :is="item.cp" v-bind="{...item.cd,editing:item.editing}"></component>
                                </div>
                            </grid-item>
                        </grid-layout>
                    </b-card>
                </b-overlay>
            </div>
        </div>
        
    </div>
    <div v-else class="template-generator-mobile">
        <button class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>

        <b-card>
            <div class="text-center">
                <div class="text-danger mb-50 font-weight-bold">Şablon oluşturma işlemi sadece <span class="font-weight-bolder">masaüstü verisiyonunda</span> yapılabilir.</div>
                <div>Tarayınıcız küçük boyutta ise genişletebilir;</div>
                <div>telefondan giriş yapılmışsa sadece <b>masaüstü versiyonundan</b> düzenlenebilir.</div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard,BBadge,BOverlay } from 'bootstrap-vue'
import VueGridLayout from 'vue-grid-layout';
import TemplateGeneratorLogo from "./components/TemplateGeneratorLogo.vue"
import TemplateGeneratorName from "./components/TemplateGeneratorName.vue"
import TemplateGeneratorTodayDate from "./components/TemplateGeneratorTodayDate.vue"
import TemplateGeneratorContent from "./components/TemplateGeneratorContent.vue"
import TemplateGeneratorDivider from "./components/TemplateGeneratorDivider.vue"
import TemplateGeneratorPreview from "./components/TemplateGeneratorPreview.vue"
import TemplateGeneratorTextEditor from "./components/TemplateGeneratorTextEditor.vue"
import TemplateGeneratorSpace from "./components/TemplateGeneratorSpace.vue"
import randomatic from 'randomatic';
import TemplateGeneratorApi from "@/api/template-generator"
import store from '@/store'

export default {
    components: {
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        TemplateGeneratorLogo,
        TemplateGeneratorName,
        TemplateGeneratorTodayDate,
        TemplateGeneratorDivider,
        TemplateGeneratorContent,
        TemplateGeneratorPreview,
        TemplateGeneratorTextEditor,
        TemplateGeneratorSpace,
        BCard,
        BBadge,
        BOverlay
    },
    data(){
        return{
            editing: this.$route.params.id != 0 || this.$route.params.id != '0' ?  true : false,
            id: this.$route.params.id,
            name:"",
            components:[
                {n:"Logo",cp:"TemplateGeneratorLogo",h:3,w:2,c:1,r:false,cd:{img:"{{companyLogo}}"},editing:true},
                {n:"Belge İsmi",cp:"TemplateGeneratorName",h:3,w:8,c:1,r:true,cd:{name:"{{documentName}}",prevName:null},editing:true},
                {n:"Bugünün Tarihi",cp:"TemplateGeneratorTodayDate",h:3,w:2,c:1,r:true,cd:{date:'{{today}}'},editing:true},
                {n:"Ayırıcı",cp:"TemplateGeneratorDivider",h:1,w:12,c:5,r:false,editing:true},
                {n:"İçerik",s:true,ah:true,cp:"TemplateGeneratorContent",h:6,w:12,c:1,r:true,editing:true},
                {n:"Yazı İçerik",e:true,ah:true,cp:"TemplateGeneratorTextEditor",h:7,w:12,c:2,r:true,cd:{value:{content:""}},editing:true},
                {n:"Boşluk",cp:"TemplateGeneratorSpace",h:2,w:2,c:10,r:true,editing:true},
            ],
            parameters:{},
            colNum: 12,
            index: 0,
            layout: [],
            previewLayout:"",
            loading:false,
            templateLoading:false,
            schemeName:null,
            schemeDescription:null
        }
    },
    mounted() {
        if(this.id != "0" || this.id != 0) this.getTemplate()
        this.index = this.layout.length
    },
    watch:{
        name(){
            let element = this.layout.find(l=> l.cp == "TemplateGeneratorName")
            element.cd.prevName = this.name
        }
    },
    methods:{
        getTemplate(){
            this.templateLoading = true
            TemplateGeneratorApi.Get(this.id).then(res=>{
                if(res.data.Success){
                    this.name = res.data.Data.DocumentName
                    this.schemeName = res.data.Data.DocumentTemplateName
                    this.schemeDescription = res.data.Data.Description
                    this.parameters = res.data.Data.Parameters
                    let scheme = res.data.Data.Scheme
                    if(scheme){
                        try {
                            let parsedScheme = JSON.parse(scheme)
                            this.layout = parsedScheme?.map(i=>{
                                if(i.cp == "TemplateGeneratorTextEditor") i.cd.parameters = res.data.Data.Parameters
                                return { ...i,editing:true}
                            })
                            this.index = Math.max(...parsedScheme?.map(i=> i.i)) + 1 || 100
                        } catch (error) {
                            this.layout = []
                        }
                    }
                }
                this.templateLoading = false
            }).catch(err=>{
                this.templateLoading = false
            })
        },
        preview(){
            this.previewLayout = JSON.stringify(this.layout)
            this.$showModal("preview")
        },
        addItem(item){
            let cd = structuredClone(item.cd)
            let bottom = Math.max(...this.layout.map(l=>l.y + l.h)) > 0 ? Math.max(...this.layout.map(l=>l.y + l.h)) : 0          
            this.layout.push({
                n:item.n,
                x: 0,
                y: bottom,
                w: item.w,
                h: item.h,
                i: this.index,
                r:item.r,
                e: item?.e || false,
                cp:item.cp,
                s: item?.s || false,
                ah:item?.ah || false,
                cd:item.e ? {...cd,parameters:this.parameters} : cd,
                dif:"a, button, .ql-editor",
                id:randomatic("A",15)
            });
            this.index++;
        },
        removeItem: function (val) {
            const index = this.layout.map(item => item.i).indexOf(val);
            this.layout.splice(index, 1);
        },
        itemAddable(comp){
            return this.layout.filter(c=>c.n == comp.n).length >= comp.c ? false : true
        },
        itemCount(comp){
            return comp.c - this.layout.filter(c=>c.n == comp.n).length
        },
        resetLayout(){
            this.$confirm('Şablonu sıfırlamak istediğinize emin misiniz?','Bu işlem geri alınamaz ve şablonu sıfırlar.').then(result=>{
                if(result){
                    this.layout = []
                }
            })
        },
        save(){
            this.loading = true
            let data = {
                Id: this.id,
                DocumentName: this.name,
                Scheme: JSON.stringify(this.layout?.map(i=>{
                    if(i.cp == "TemplateGeneratorTextEditor") i.cd.parameters = {}
                    return { ...i, editing:false }
                }))
            }
            TemplateGeneratorApi.Update(data).then(res=>{
                this.loading = false
                this.$result(res)
                if(res.data.Success) this.$router.push({name:'template'})
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        back(){
            this.$router.push({name:'template'})
        }
    },
    computed:{
        isMobile(){
            return store.state.verticalMenu.isMobile
        }
    }
}
</script>

<style>
.sticky{
    position:sticky;
    top:1.5rem;
}
.empty-template{
    height:100px;
    width:100%;
    background-color:rgba(0,0,0,0.02);
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:0.375rem;
    flex-direction: column;
}
.vue-grid-item{
    touch-action: none;
}

.vue-grid-item.editor{
    z-index: 2;
}

.vue-grid-item.vue-grid-placeholder {
    background: rgba(30, 70, 143,0.5);
    opacity: 0.2;
    transition-duration: 100ms;
    z-index: 2;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
} 
.grid{
    background-color: rgba(0,0,0,0.02);
    border-radius:0.375rem
}

.dark-layout .grid{
    background-color: rgba(255,255,255,0.1);
}
.grid::before {
    content: '';
    background-size: calc(calc(100% - 5px) / 12) 40px;
    background-image: linear-gradient(
            to right,
            rgba(0,0,0,0.1) 1px,
            transparent 1px
    ),
    linear-gradient(to bottom, rgba(0,0,0,0.2) 1px, transparent 1px);
    height: calc(100% - 5px);
    width: calc(100% - 5px);
    position: absolute;
    background-repeat: repeat;
    margin:5px;
    clip-path: inset(0px 4px 4px 0px);
}

.grid .grid-item-wrapper{
    background-color: white;
    height: 100%;
    width:100%;
    border: 1px dashed rgba(0,0,0,0.2);
}

.grid .grid-item-wrapper .delete-button{
    opacity: 0;
    transition: opacity 0.25s linear;
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 0.7rem;
    padding: 0.243rem 0.5rem;
}

.grid-item-wrapper:hover .delete-button{
    opacity: 1;
}

.dark-layout .grid::before {
    background-image: linear-gradient(
            to right,
            rgba(255,255,255,0.2) 1px,
            transparent 1px
    ),
    linear-gradient(to bottom, rgba(255,255,255,0.1) 1px, transparent 1px);
}

</style>